import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getWorkFlowList } from "../../../services/Workflow";
import './styles/ViewWorkflows.scss';
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { appRoutes } from '../../../utils/routes';
import { FolderX } from 'react-bootstrap-icons'
import { SampleStatusMasterData } from "../../../utils/sampleStatusMasterData";
import { ViewWorkflowDetails } from "../../ViewPatient/components/ViewWorkflowDetails";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { AxiosResponse } from "axios";
import { WorkflowRequestPayload } from "../../../models/Workflow";
import { AppUtil } from "../../../utils/app.utils";
import { SampleStatusMasterData as SampleStatusMasterDataValue } from "../../SampleInformationForm/helpers";
import { AuthUtil } from "../../../utils/auth.utils";
import { PRIVILEGES } from "../../../utils/constants";

const ViewWorkflows = () => {
    const { id } = useParams()
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { promiseInProgress } = usePromiseTracker();

    const translatn = 'viewWorkflow.'
    const parentClass = 'view-workflow'

    const [workflowList, setWorkflowList] = useState<WorkflowRequestPayload[]>([]);
    const hasEditWorkflowPrivilege = AuthUtil.checkUserAccess(PRIVILEGES.EDIT_WORKFLOW)

    useEffect(() => {
        if (id) {
            trackPromise(
                getWorkFlowList(id).then(
                    (res: AxiosResponse<WorkflowRequestPayload[]>) => {
                        if (res.status == 200) {
                            setWorkflowList(res.data)
                        }
                    },
                    (error) => AppUtil.logError(error),
                ),
            )
        }
    }, [id])

    const handleEditWorkflow = (workflowItem: WorkflowRequestPayload) => {
        if (hasEditWorkflowPrivilege && !(workflowItem.status === SampleStatusMasterDataValue.sampleStatusValueMap.report_ready)) {
            navigate(generatePath(appRoutes.editWorkflow, { patientId: workflowItem.patientId, id: workflowItem.id }))
        }
    }

    const renderWorkflowAccordion = (workflowItem: WorkflowRequestPayload) => {
        const key = workflowItem.id?.toString() ?? ''
        return <div className={`${parentClass}`} key={key}>
            <Accordion.Item eventKey={key} key={key}>
                <Accordion.Header>
                    <span
                        className={`${parentClass}-accordion-left-text`}
                    >
                        {t(`${translatn}workflowId`) + ' : ' + workflowItem.id}
                    </span>
                    <span className={`${parentClass}-accordion-right-text`} onClick={() => handleEditWorkflow(workflowItem)}>
                        {t(`${translatn}workflowStatus`)}
                        {' : '}
                        {t(`sampleStatus.${SampleStatusMasterData.getValue(workflowItem.status)}`)}
                    </span>
                </Accordion.Header>
                <Accordion.Body>
                    <ViewWorkflowDetails workflow={workflowItem}/>
                </Accordion.Body>
            </Accordion.Item>
        </div>
    }

    return (
        <div className={`${parentClass}`}>
            {!promiseInProgress ? (workflowList.length ? (
                <Accordion defaultActiveKey={workflowList.length === 1 ? workflowList[0]?.id?.toString() : null}>
                    {workflowList.map((workflowItem: WorkflowRequestPayload) => renderWorkflowAccordion(workflowItem))}
                </Accordion>
            ) : (
                <div className={`${parentClass}-empty-container`}>
                    <FolderX size={'32'} />
                    <h5>{t(`${translatn}noWorkflows`)}</h5>
                </div>

            )) : <></>}
        </div>
    );
};
export default ViewWorkflows;